<template>
  <a-form
    ref="formRef"
    layout="vertical"
    :model="form"
    class="form"
  >
    <a-form-item
      :label="$t('weekly.progress')"
      name="currentProgress"
      :rules="{
        type: 'string',
      }"
    >
      <a-textarea
        v-model:value="form.currentProgress"
        :placeholder="$t('okr.personalObjective.placeholder')"
        :auto-size="{ minRows: 6, maxRows: 6 }"
      />
    </a-form-item>
    <a-form-item
      :label="$t('weekly.risk')"
      name="currentRisk"
      :rules="{
        type: 'string',
      }"
    >
      <a-textarea
        v-model:value="form.currentRisk"
        :placeholder="$t('okr.personalObjective.placeholder')"
        :auto-size="{ minRows: 6, maxRows: 6 }"
      />
    </a-form-item>
    <a-form-item
      :label="$t('weekly.comments')"
      name="remarks"
      :rules="{
        type: 'string',
      }"
    >
      <a-textarea
        v-model:value="form.remarks"
        :placeholder="$t('okr.personalObjective.placeholder')"
        :auto-size="{ minRows: 6, maxRows: 6 }"
      />
    </a-form-item>
    <progress-edit
      :key-result="keyResult"
      @progress-updated="updateProgressData"
    />
  </a-form>
  <FormAction
    :loading="loading"
    :can-close="canClose"
    @cancel="emit('cancel')"
    @save="onSave()"
  />
</template>
<script setup>
import { ref, toRefs, defineEmits, unref, watch } from 'vue'
import FormAction from '@/views/OkrList/FormAction.vue'
import ProgressEdit from './progress-edit.vue'
import { editOkrWeeklyList } from '@/api/weekly'
import { updateKeyResult } from '@/api/okr'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
const emit = defineEmits(['cancel', 'update:canClose'])
const props = defineProps({
  weekData: {
    type: Object,
    default: () => {}
  },
  updateWeekData: {
    type: Function,
    default: () => {}
  },
  keyResult: {
    type: Object,
    default: () => {}
  },
  canClose: {
    type: Boolean,
    required: true
  }
})
const { t } = useI18n()
const { updateWeekData } = toRefs(props)
const form = unref(ref(JSON.parse(JSON.stringify(props.weekData))))
const formRef = ref()

const loading = ref(false)
const onSave = async () => {
  loading.value = true
  try {
    await formRef.value.validate()
  } catch (_) {
    loading.value = false
    return
  }
  const params = {
    id: form.id,
    current_progress: form.currentProgress,
    current_risk: form.currentRisk,
    remarks: form.remarks,
    objective_id: form.objectiveId,
    keyresult_id: form.keyresultId,
    okrlist_id: form.okrlistId,
    week_date: form.weekDate
  }
  const promises = [editOkrWeeklyList(params)]
  if (progressData.value) {
    promises.push(updateKeyResult(props.keyResult.krId, progressData.value))
  }
  Promise.all(promises).then(([res1, res2]) => {
    loading.value = false
    updateWeekData.value(res1, progressData.value)
    emit('cancel')
    message.success(t('weekly.editSuccess'))
  }).catch(e => {
    console.log(e)
  })
}

const progressData = ref()
const updateProgressData = (val) => {
  progressData.value = val
  emit('update:canClose', false)
}

watch(form, () => {
  emit('update:canClose', false)
})
</script>
